

















import Vue from 'vue';
import * as Util from '@/util.ts';
import * as Constants from '@/constants.ts';

export default Vue.extend({
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      location,
    };
  },
  computed: {
    url(): string {
      const self: any = this;
      return self.$store.state.logoUrl;
    },
    establishmentName(): string {
      const self: any = this;
      return self.$store.state.currentEstablishment.name;
    },
    currentLogo(): string {
      const self: any = this;
      const logo: Image = self.$store.state.currentMenu.images?.length ? this.$store.state.currentMenu.images[0] : this.$store.state.currentEstablishment.images[0];
      return logo ? logo.url : '';
    },
    menuSelectionPossible() {
      const self: any = this;
      return self.$store.state.menuSelectionPossible && (window.location.pathname === '/' || window.location.pathname === '/menu');
    },
    isDemoLocation(): boolean {
      return this.$store.state.isDemoLocation;
    },
  },
  methods: {
    showMenuSelection() {
      Util.showMenuSelection();
    },
    onBrandClick() {
      if (this.isDemoLocation) {
        Util.routerPush({ path: Constants.allRoutes.demoMenuModal });
      } else if (this.$store.state.menuSelectionPossible) {
        Util.routerPush({ path: Constants.allRoutes.menuSelection });
      } else if (this.$store.state.currentEstablishment.description) {
        Util.routerPush({ path: Constants.allRoutes.aboutUsModal });
      }
    },
  },
});
